import { useForm, Control, useWatch } from 'react-hook-form';

import { useEmailValidateUserMutation } from 'api';
import { PasswordResetFormValues } from 'types';

import { defaultValues } from './config';

interface UseRestorePasswordFormReturn {
  isSubmitting: boolean;
  handleFormSubmit: () => void;
  control: Control<PasswordResetFormValues>;
}

interface UseRestorePasswordFormProps {
  setEmail: (email: string) => void;
  setEmailExist: (value: boolean) => void;
  requestPasswordResetMutation: (data: PasswordResetFormValues) => void;
}

export function useRestorePasswordForm({
  setEmail,
  setEmailExist,
  requestPasswordResetMutation,
}: UseRestorePasswordFormProps): UseRestorePasswordFormReturn {
  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<PasswordResetFormValues>({
    defaultValues,
    mode: 'onBlur',
  });

  const email = useWatch({
    control,
    name: 'email',
  });

  const { emailValidationMutation } = useEmailValidateUserMutation({});

  const handleFormSubmit = handleSubmit(async (data) => {
    const response = await emailValidationMutation({ email });
    if (response.data?.active_user_exists) {
      await requestPasswordResetMutation(data);
      setEmailExist(true);
      setEmail(data.email);
    } else {
      setEmailExist(false);
    }
  });

  return {
    control,
    handleFormSubmit,
    isSubmitting,
  };
}
